import { buildCardImageBaseUrl } from "../../buildCardImageUrl";
import { createSchemeChoiceRadioButton } from "../schemeChoiceOption";

import "./SchemeChoiceRadioButtonBase.css";

class SchemeChoiceRadioButton {
  state = {
    preferredScheme: "",
  };

  previousState;
  onValueChange;
  radioSelect;

  constructor(env, { onValueChange }) {
    this.env = env;
    this.appUrl = this.env.APP_URL;
    this.imageUrl = buildCardImageBaseUrl(this.appUrl);
    this.onValueChange = onValueChange;
    this.previousState = { ...this.state };

    this.radioSelect = document.getElementById(
      "checkout-frames-radio-selector"
    );

    this.registerEventHandlers();
  }

  registerEventHandlers = () => {
    this.radioSelect.addEventListener("change", this.onSelectChange);
  };

  onSelectChange = (event) => {
    this.state.preferredScheme = event.target.value;
    this.dispatchNewValue();
  };

  dispatchNewValue = () => {
    this.onValueChange(this.state.preferredScheme);
  };

  toggleElementVisibility = (messageValue) => {
    if (messageValue.isDisplayed) {
      this.initializeSelectValues(
        messageValue.schemes,
        messageValue.defaultValue
      );
      this.state.preferredScheme = messageValue.defaultValue;
    } else {
      this.state.preferredScheme = "";
    }

    this.dispatchNewValue();
  };

  initializeSelectValues = (schemes, defaultValue) => {
    this.radioSelect.innerHTML = schemes
      .map((scheme) => {
        return createSchemeChoiceRadioButton(scheme, this.imageUrl);
      })
      .join(" ");

    if (defaultValue) {
      document.getElementById(defaultValue).checked = true;
    } else {
      const element = document.getElementById(schemes[0]);
      element.checked = true;
    }
  };
}

export default SchemeChoiceRadioButton;
